var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first-step"},_vm._l((_vm.items),function(itm,index){return _c('div',{key:'first-step-item-' + index,style:({
      width: itm.style.width + '%',
      top: itm.style.top + '%',
      left: itm.style.left + '%',
      cursor: itm.style.cursor,
      top: itm.style.top + '%',
      bottom: itm.style.bot + '%',
      left: itm.style.left + '%',
      right: itm.style.right + '%',
      background: itm.style.bcg,
      width: itm.style.width + '%',
      height: itm.style.height + '%',
      opacity: itm.style.opacity,
      color: itm.style.color || _vm.mainColor,
      transform: itm.style.transform,
      position: 'absolute',
    })},[(itm.type == 'img')?_c('img',{class:itm.style.class,style:({
        width: '100%',
        height: '100%',
        cursor: itm.style.cursor,
        objectPosition: itm.style.objectPosition | 'left bottom',
        animationDelay: (itm.style.delay | 0) / 100 + 's',
      }),attrs:{"src":itm.content}}):_vm._e(),(itm.type == 'text')?_c('div',{staticClass:"box",class:itm.style.class + ' ' + itm.style.hover,style:({
        animationDelay: (itm.style.delay | 0) / 100 + 's',
        borderColor: _vm.mainColor,
      }),on:{"click":function($event){return _vm.firstStepOff()}}},[_c('p',{class:itm.style.class + ' ' + itm.style.hover,style:({
          width: '100%',
          fontSize: itm.style.fontSize + 'rem',
          margin: itm.style.margin || 0,
          fontFamily: itm.style.font || 'Arial',
          animationDelay: (itm.style.delay | 0) / 100 + 's',
        }),domProps:{"innerHTML":_vm._s(itm.content)}})]):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }